// extracted by mini-css-extract-plugin
export default {"menu-item":"Menu_menu-item__D-aJg","active":"Menu_active__YO+RX","icon":"Menu_icon__w85yF","title":"Menu_title__VcSW6"};